import { Table } from "antd";

function CustomTable({
    columns,
    tableData,
    noOfrecords,
    handleTableChange,
    rowKey,
    className = "",
    currentPage = 1,
    currentPageLimit = 10,
    isScroll,
    pagination,
    ...rest
}) {
    return (
        <Table
            columns={columns}
            dataSource={tableData}
            rowKey={rowKey}
            // Always apply base class + any additional class passed in
            className={`dashboard-table ${className}`.trim()}
            onChange={handleTableChange}
            size="middle"
            scroll={{ x: isScroll ? "max-content" : undefined }}
            pagination={
                pagination ?? {
                    hideOnSinglePage: false,
                    responsive: true,
                    total: noOfrecords,
                    defaultPageSize: currentPageLimit,
                    defaultCurrent: currentPage,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 20, 50],
                    showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} records`,
                }
            }
            {...rest}
        />
    );
}

export default CustomTable;
